export const ADD_PRODUCT_TO_SHOPPING_CART = "ADD_PRODUCT_TO_SHOPPING_CART";
export const REMOVE_PRODUCT_FROM_SHOOPING_CART =
	"REMOVE_PRODUCT_FROM_SHOOPING_CART";
export const ADD_COMMENT_SHOP = "ADD_COMMENT_SHOP";
export const REMOVE_ALL_PRODUCTS_FROM_SHOOPING_CART =
	"REMOVE_ALL_PRODUCTS_FROM_SHOOPING_CART";
export const ADD_TIP_SHOP = "ADD_TIP_SHOP";
